/** Catálogo offline (mismo contenido que backend catalog_seed.py) */
export const CATALOG_FALLBACK = [
  {
    id: 1,
    name: "Manzana Roja",
    stock: 45,
    unit: "kg",
    category: "Frutas",
    description: "Manzana gala, dulce y crujiente.",
    price: 60,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Red_Apple.jpg/800px-Red_Apple.jpg",
  },
  {
    id: 2,
    name: "Banana",
    stock: 55,
    unit: "kg",
    category: "Frutas",
    description: "Banana de primera, madura y dulce.",
    price: 35,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Banana-Fruit-2.jpg/800px-Banana-Fruit-2.jpg",
  },
  {
    id: 3,
    name: "Naranja Valencia",
    stock: 40,
    unit: "kg",
    category: "Cítricos",
    description: "Jugosa y rica en vitamina C.",
    price: 42,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Clementine_whole.jpg/800px-Clementine_whole.jpg",
  },
  {
    id: 4,
    name: "Limón",
    stock: 35,
    unit: "kg",
    category: "Cítricos",
    description: "Limón fresco y aromático.",
    price: 38,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Lemons.jpg/800px-Lemons.jpg",
  },
  {
    id: 5,
    name: "Palta Hass",
    stock: 28,
    unit: "kg",
    category: "Frutas",
    description: "Palta cremosa.",
    price: 120,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Avocado_Hass_-_single_and_halved.jpg/800px-Avocado_Hass_-_single_and_halved.jpg",
  },
  {
    id: 6,
    name: "Frutilla",
    stock: 22,
    unit: "kg",
    category: "Frutas",
    description: "Frutillas de estación.",
    price: 95,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Single_strawberry.jpg/800px-Single_strawberry.jpg",
  },
  {
    id: 7,
    name: "Uva Verde",
    stock: 18,
    unit: "kg",
    category: "Frutas",
    description: "Uvas sin semilla.",
    price: 88,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Kyoho-grape.jpg/800px-Kyoho-grape.jpg",
  },
  {
    id: 8,
    name: "Pera Williams",
    stock: 26,
    unit: "kg",
    category: "Frutas",
    description: "Pera jugosa.",
    price: 72,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Pears.jpg/800px-Pears.jpg",
  },
  {
    id: 9,
    name: "Lechuga Bola",
    stock: 30,
    unit: "pza",
    category: "Verduras",
    description: "Lechuga iceberg fresca.",
    price: 30,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Iceberg_lettuce_in_SB.jpg/800px-Iceberg_lettuce_in_SB.jpg",
  },
  {
    id: 10,
    name: "Tomate Perita",
    stock: 50,
    unit: "kg",
    category: "Verduras",
    description: "Tomate maduro.",
    price: 45,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Tomato_je.jpg/800px-Tomato_je.jpg",
  },
  {
    id: 11,
    name: "Zanahoria",
    stock: 60,
    unit: "kg",
    category: "Verduras",
    description: "Zanahoria dulce.",
    price: 28,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Vegetable-Carrot-Bundle-wStalks.jpg/800px-Vegetable-Carrot-Bundle-wStalks.jpg",
  },
  {
    id: 12,
    name: "Cebolla Blanca",
    stock: 48,
    unit: "kg",
    category: "Verduras",
    description: "Cebolla versátil.",
    price: 32,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Onion_on_white_background.jpg/800px-Onion_on_white_background.jpg",
  },
  {
    id: 13,
    name: "Papa",
    stock: 70,
    unit: "kg",
    category: "Verduras",
    description: "Papa lavada.",
    price: 25,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Patates.jpg/800px-Patates.jpg",
  },
  {
    id: 14,
    name: "Morrón Rojo",
    stock: 24,
    unit: "kg",
    category: "Verduras",
    description: "Morrón carnoso.",
    price: 58,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Red_capsicum_and_cross_section.jpg/800px-Red_capsicum_and_cross_section.jpg",
  },
  {
    id: 15,
    name: "Zapallo Cabutia",
    stock: 20,
    unit: "kg",
    category: "Verduras",
    description: "Zapallo anco dulce.",
    price: 40,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/FruitingPumpkin.jpg/800px-FruitingPumpkin.jpg",
  },
  {
    id: 16,
    name: "Pepino",
    stock: 32,
    unit: "kg",
    category: "Verduras",
    description: "Pepino fresco.",
    price: 36,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Cucumbers.jpg/800px-Cucumbers.jpg",
  },
  {
    id: 17,
    name: "Espinaca",
    stock: 18,
    unit: "atado",
    category: "Verduras",
    description: "Espinaca tierna.",
    price: 34,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Spinach_leaves.JPG/800px-Spinach_leaves.JPG",
  },
  {
    id: 18,
    name: "Brócoli",
    stock: 16,
    unit: "pza",
    category: "Verduras",
    description: "Brócoli verde firme.",
    price: 48,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Broccoli_and_cross_section_edit.jpg/800px-Broccoli_and_cross_section_edit.jpg",
  },
  {
    id: 19,
    name: "Albahaca",
    stock: 14,
    unit: "atado",
    category: "Hierbas",
    description: "Albahaca fresca.",
    price: 38,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Basil-Basilicum_photo-1.jpg/800px-Basil-Basilicum_photo-1.jpg",
  },
  {
    id: 20,
    name: "Perejil",
    stock: 20,
    unit: "atado",
    category: "Hierbas",
    description: "Perejil aromático.",
    price: 28,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Petroselinum_crispum_20101017.jpg/800px-Petroselinum_crispum_20101017.jpg",
  },
  {
    id: 21,
    name: "Cilantro",
    stock: 16,
    unit: "atado",
    category: "Hierbas",
    description: "Cilantro fresco.",
    price: 30,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Coriander_plant.jpg/800px-Coriander_plant.jpg",
  },
  {
    id: 22,
    name: "Orégano Seco",
    stock: 40,
    unit: "pza",
    category: "Condimentos",
    description: "Orégano para cocina.",
    price: 22,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Origanum_vulgare_-_harilik_pune.jpg/800px-Origanum_vulgare_-_harilik_pune.jpg",
  },
  {
    id: 23,
    name: "Ajo",
    stock: 35,
    unit: "kg",
    category: "Condimentos",
    description: "Ajo seleccionado.",
    price: 52,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Garlic_Thassos.jpg/800px-Garlic_Thassos.jpg",
  },
  {
    id: 24,
    name: "Huevo Rojo",
    stock: 80,
    unit: "docena",
    category: "Pecuarios",
    description: "Huevo fresco.",
    price: 55,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Fresh_eggs.jpg/800px-Fresh_eggs.jpg",
  },
  {
    id: 25,
    name: "Pechuga de Pollo",
    stock: 12,
    unit: "kg",
    category: "Pecuarios",
    description: "Pechuga sin hueso.",
    price: 249,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Chicken_breast.jpg/800px-Chicken_breast.jpg",
  },
  {
    id: 26,
    name: "Queso Crema",
    stock: 25,
    unit: "pza",
    category: "Pecuarios",
    description: "Queso crema untable.",
    price: 68,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Cheese_platter.jpg/800px-Cheese_platter.jpg",
  },
  {
    id: 27,
    name: "Leche Entera",
    stock: 36,
    unit: "lt",
    category: "Pecuarios",
    description: "Leche 1 litro.",
    price: 42,
    image_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Milk_glass.jpg/800px-Milk_glass.jpg",
  },
];
